import { render, staticRenderFns } from "./TagInput.vue?vue&type=template&id=31a8d97b&scoped=true"
import script from "./TagInput.vue?vue&type=script&lang=js"
export * from "./TagInput.vue?vue&type=script&lang=js"
import style0 from "./TagInput.vue?vue&type=style&index=0&id=31a8d97b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a8d97b",
  null
  
)

export default component.exports